import { useParams } from "react-router-dom";
import FormProduct from "../components/FormProduct";

// import FormProduct from '../components/FormProduct';
import { ACTION } from "../conts";

const ProductGroupCreate = () => {
  const { id } = useParams();

  return <FormProduct action={id ? ACTION.CLONE_PRODUCT : ACTION.CREATE} />;
};

export default ProductGroupCreate;
